function openCartDrawer() {
  //Open cart drawer
  document.body.style.overflow = "hidden";
  document.querySelector('.cart-drawer-box').classList.add('cart-drawer-active');
}
function closeCartDrawer() {
  //Close cart drawer
  document.body.style.overflow = "auto";
  document.querySelector('.cart-drawer-box').classList.remove("cart-drawer-active");
}
function openCartIcon() {
  // cart icon is clicked, open cart drawer
  document.querySelectorAll('a[href="/cart"]').forEach(a => {
    a.addEventListener("click", (e) => {
      e.preventDefault();
      //Open cart drawer
      openCartDrawer();
    });
  });
}
async function updateCartIcon() {
  const res = await fetch('/?section_id=header');
  const text = await res.text();
  const html = document.createElement("header");
  html.innerHTML = text;
  const newCartToggle = html.querySelector(".cartToggle");
  const currentCartToggle = document.querySelector('.cartToggle');
  if(newCartToggle && currentCartToggle) {
    currentCartToggle.replaceWith(newCartToggle);
  }
  openCartIcon();
}


function addCartDrawerListener() {
  // Update quantities
  document.querySelectorAll('.cart-drawer-minus, .cart-drawer-plus, .cart-drawer-clear')
    .forEach((button) => {
      button.addEventListener("click", async () => {
        const rootItem = button.closest('.cart-drawer-item');
        const currentQuantity = Number(button.parentElement.querySelector('.cart-drawer-quantity').getAttribute("value"));
        const key = rootItem.getAttribute("data-line-item-key");
        const isUp = button.classList.contains("cart-drawer-plus");
        const isClear = button.classList.contains("cart-drawer-clear");
        const newQuantity = isUp ? currentQuantity + 1 : isClear ? 0 : currentQuantity - 1 ;
        
        // Ajax update
        const res = await fetch("/cart/update.js", {
          method: "post",
          "headers": {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({updates: {[key]: newQuantity} }),
          });
        const json = await res.json();
        updateCartDrawer()
        
      });
  });
  // close cart
  document.querySelectorAll('.cart-drawer-box, .cart-drawer-close').forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      closeCartDrawer();
    });
  });
  document.querySelector('.cart-drawer-wrapper').addEventListener("click", (e) => {
    e.stopPropagation();
  });
}

addCartDrawerListener();
openCartIcon();
// Add to cart ajax


document.addEventListener("click", async (e) => {
  if (e.target.matches('[data-add-to-cart')) {
    e.preventDefault();
    
    var form = e.target.closest('form');
    
    // Submit form with ajax
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    // Update cart
    await updateCartDrawer();
    
    //Open cart drawer
    openCartDrawer()
  }
})



document.addEventListener("submit", async (e) => {
  // Check if the form is the "Add to Cart" form
  if (e.target.closest('.add-to-cart-form')) {
    e.preventDefault(); // Prevent the form from submitting traditionally

    var form = e.target.closest('form'); // Get the form element
    
    // Create FormData object from the form
    const formData = new FormData(form);
    
    // Send the data to the /cart/add.js endpoint via AJAX
    const res = await fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    });

    if (res.ok) {
      // Successfully added the product to the cart, now update the cart drawer
      await updateCartDrawer();

      // Optionally, you can open the cart drawer to show the updated cart content
      openCartDrawer();
    } else {
      console.error("Error adding product to cart");
    }
  }
});

// // Function to update the cart drawer content
// async function updateCartDrawer() {
//   const res = await fetch('/?section_id=cart-drawer');
//   const text = await res.text();
//   const html = document.createElement("div");
//   html.innerHTML = text;
//   const newBox = html.querySelector(".cart-drawer-box").innerHTML;
//   document.querySelector('.cart-drawer-box').innerHTML = newBox;
//   updateCartIcon(); // Update the cart icon
//   addCartDrawerListener(); // Reattach listeners for cart actions (like quantity updates)
// }


async function updateCartDrawer() {
  const res = await fetch('/?section_id=cart-drawer');
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".cart-drawer-box").innerHTML;
  document.querySelector('.cart-drawer-box').innerHTML = newBox;

  updateCartIcon(); // Update the cart icon
  addCartDrawerListener(); // Reattach listeners for cart actions (like quantity updates)

  // After the cart is refreshed, check if "Alpha Buck" is in the cart
  checkAndHideProductCard();
}

// Function to check if "Alpha Buck" is in the cart and hide the recommended product
function checkAndHideProductCard() {
  let cartItems = document.querySelectorAll(".cart-drawer-title");
  let productCard = document.querySelector(".product-card.alpha-bunk");

  if (cartItems.length && productCard) {
    let productExists = Array.from(cartItems).some(item => item.textContent.trim() === "Alpha Buck");

    if (productExists) {
      productCard.style.display = "none"; // Hide if product exists
    } else {
      productCard.style.display = "block"; // Show if product doesn't exist
    }
  }
}

// Listen for cart updates dynamically
document.addEventListener("cart:updated", updateCartDrawer);

// Optionally, if your theme uses jQuery to trigger cart updates, add this listener:
$(document).on("ajax:success", function () {
  document.dispatchEvent(new Event("cart:updated"));
});

